import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,

} from "reactstrap";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Loader from "../../components/Common/Loader";


import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter, useHistory, useParams, Link } from "react-router-dom";
//Action

import { informesFilter, informesUpdate } from "../../store/informes/actions";

import { casosFilter } from "../../store/casos/actions";
import { casosDetallesFilter } from "../../store/actions";



import { userFullList } from "../../store/admin/user/actions";

const InformeVer = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const param = useParams();
  const str = param.id;
  const InformeId = Number(str);
  const casoId = Number(props.informes.caso);
  const URL = process.env.REACT_APP_API_URL.split("/api").join("");

  // console.log(URL)

  useEffect(() => {
    dispatch(informesFilter(`${InformeId}/`));
    dispatch(userFullList());
  }, [dispatch, InformeId]);

  useEffect(() => {
    dispatch(casosFilter(`${casoId}/`));

    dispatch(casosDetallesFilter(`get_gestiones_caso/?caso=${casoId}`));
  }, [dispatch, casoId]);



 

  const informe = useSelector((state) => state.Informes.informes);



  const foto =
    informe.images && informe.images.length > 0
      ? informe.images.map((image) => image)
      : [];

  const [formData, setFormData] = useState({
    observaciones: informe.observaciones,
  });

  const { observaciones } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    props.informesUpdate(informe.id, {
      informe_visita: informe.informe_visita,
      repuesto_materiales: informe.repuesto_materiales,
      observaciones: observaciones,
      persona_recibe_servicio: informe.persona_recibe_servicio,
      cargo_persona_recibe_servicio: informe.cargo_persona_recibe_servicio,
      caso: informe.caso,
    });
  };

  const redirect = () => {
    history.goBack();
  };


 
  const Menu = () => (
    <Button
      variant="dark"
      onClick={() => {
        window.open(`${URL}/reportes/informe_pdf/${InformeId}/`, '_blank');
      }}
    >
      Ver PDF
    </Button>
  );

  return (
    <React.Fragment>



      {props.informesUpdated.id ? (
        <SweetAlert
          title="Hecho!"
          success
          timeout={1000}
          showConfirm={false}
          onConfirm={() => {
            redirect();
          }}
        >
          Se actualizado el informe
        </SweetAlert>
      ) : null}
      <div className="page-content">
        <MetaTags>
          <title> Ver visita tecnica </title>
        </MetaTags>

        <Container fluid>
          <Breadcrumb breadcrumbItem={`Informe ${informe.id}`} />
          {props.loading ? (
            <Loader
            
            
            />
          ) : (
            <>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={7}>
                      <button
                        className="btn btn-primary waves-effect waves-light"
                        onClick={redirect}
                      >
                        Ir a Atras
                      </button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Row className="justify-content-center">
                <h4 className="card-title">Ver visita tecnica</h4>
                <Form
                  className="form-control needs-validation justify-content-center"
                  onSubmit={onSubmit}
                >
                  <Row className="col-lg-12 justify-content-center">
                    <Col lg={6} className="mb-10">
                      <Label
                        for="informe_visita"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>Informe Visita</strong>
                      </Label>

                      <textarea
                        className="form-control"
                        id="informe_visita"
                        name="informe_visita"
                        type="textarea"
                        rows="4"
                        disabled
                        value={informe.informe_visita}
                      />
                    </Col>
                  </Row>
                  <Row className="col-lg-12 justify-content-center">
                    <Col lg={6} className="mb-10">
                      <Label
                        for="repuesto_materiales"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>Repuestos y/o Materiales </strong>
                      </Label>

                      <textarea
                        className="form-control"
                        id="repuesto_materiales"
                        name="repuesto_materiales"
                        type="textarea"
                        rows="4"
                        disabled
                        value={informe.repuesto_materiales}
                      />
                    </Col>
                  </Row>
                  <Row className="col-lg-12 justify-content-center">
                    <Col lg={6} className="mb-10">
                      <Label
                        for="observaciones"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>Observaciones</strong>
                      </Label>

                      <textarea
                        className="form-control"
                        id="observaciones"
                        name="observaciones"
                        type="textarea"
                        rows="4"
                        onChange={onChange}
                        defaultValue={informe.observaciones}
                      />
                    </Col>
                  </Row>

                  <Row className="col-lg-12 justify-content-center mt-2">
                    <Col lg={6} className="mb-10">
                      {foto.length !== 0 ? (
                        <div style={{ display: "flex" }}>
                          {foto.map((image, index) => (
                            <img
                              key={index}
                              src={`${URL}${image}`}
                              alt=""
                              style={{
                                display: "block",
                                margin: "0 auto",
                                border: "2px dashed",
                                width: "150px",
                              }}
                            />
                          ))}
                        </div>
                      ) : null}
                    </Col>
                  </Row>

                  <Row className="col-lg-12 justify-content-center mt-2">
                    <Col lg={3} className="mb-10">
                      <Label
                        for="persona_recibe_servicio"
                        className="col-form-label col-sm-6 d-flex"
                      >
                        <strong>Persona Contacto</strong>
                      </Label>

                      <input
                        className="form-control"
                        id="persona_recibe_servicio"
                        name="persona_recibe_servicio"
                        type="text"
                        disabled
                        value={informe.persona_recibe_servicio}
                      />
                    </Col>

                    <Col lg={3} className="mb-10">
                      <Label
                        for="cargo_persona_recibe_servicio"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>Cargo</strong>
                      </Label>

                      <input
                        className="form-control"
                        id="cargo_persona_recibe_servicio"
                        name="cargo_persona_recibe_servicio"
                        type="text"
                        disabled
                        value={informe.cargo_persona_recibe_servicio}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    {informe.firma !== "" ? (
                      <Row className="justify-content-around">
                        <img
                          src={`${URL}${informe.firma}`}
                          alt="mi firma"
                          style={{
                            display: "block",
                            margin: "10px  auto",
                            border: "2px dashed #000000",
                            width: "350px",
                            backgroundColor: "white",
                          }}
                        />
                      </Row>
                    ) : null}
                  </Row>

                  <Row className="col-lg-12 justify-content-center mt-2">
                    <Col md={1} className="mx-1">
                      {/* <Button color="primary" className="btn btn-primary waves-effect waves-light" >
                                            Actualizar 
                                          </Button> */}
                    </Col>
                    <Col md={1} className="mx-1">
                      <Link color="primary" to={`/Informes/${informe.caso}`}>
                        Volver
                      </Link>
                    </Col>

                    <Col md={1} className="mx-1">
                      <Menu />
                    </Col>
                
                  
                  </Row>
                </Form>
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, informes, informesUpdated } = state.Informes;
  return { error, loading, informes, informesUpdated };
};

InformeVer.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  informesUpdated: PropTypes.object,
};

export default withRouter(
  connect(mapStateToProps, { informesUpdate })(InformeVer)
);
